/*
 * File: /src/router/routes/groups.js
 * Created Date: Friday June 14th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 14th June 2019 10:46:11 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
const ContactsGroups = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/Groups/GroupsList.vue'
  );
const ContactsGroupsAdd = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/Groups/GroupsAdd.vue'
  );

const ContactsGroupsEdit = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/Groups/GroupsEdit.vue'
  );
export const groupRoutes = [
  {
    path: 'contacts/groups',
    name: 'Listing Contact Groups',
    component: ContactsGroups
  },
  {
    path: 'contacts/groups/edit/:id',
    name: 'Contact Group Edit',
    component: ContactsGroupsEdit
  },
  {
    path: 'contacts/groups/add',
    name: 'Add New Contact Group',
    component: ContactsGroupsAdd
  },

];
